var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10630_189498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.52639 15.8225L0.677791 14.9741C0.599591 14.8959 0.599591 14.7693 0.677791 14.6913L4.73039 10.6387C4.80859 10.5605 4.93519 10.5605 5.01319 10.6387L5.86179 11.4871C5.93999 11.5653 5.93999 11.6919 5.86179 11.7699L1.80919 15.8225C1.73119 15.9007 1.60459 15.9007 1.52639 15.8225Z",
    fill: "#5D6590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1105 2.17617C12.4263 2.17617 14.3105 4.06037 14.3105 6.37617C14.3105 8.69197 12.4263 10.5762 10.1105 10.5762C7.79475 10.5762 5.91055 8.69197 5.91055 6.37617C5.91055 4.06037 7.79475 2.17617 10.1105 2.17617ZM10.1105 0.576172C6.90735 0.576172 4.31055 3.17297 4.31055 6.37617C4.31055 9.57937 6.90735 12.1762 10.1105 12.1762C13.3137 12.1762 15.9105 9.57937 15.9105 6.37617C15.9105 3.17297 13.3137 0.576172 10.1105 0.576172Z",
    fill: "#5D6590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.91658 6.39893C6.79918 6.39993 6.70858 6.29993 6.71518 6.18273C6.74518 5.65533 6.89878 5.13933 7.16438 4.67853C7.68798 3.76973 8.59998 3.15693 9.63178 3.00973C9.74358 2.99373 9.84438 3.07993 9.85338 3.19233L9.95098 4.39313C9.95918 4.49393 9.89118 4.58633 9.79178 4.60433C9.27218 4.69813 8.81658 5.01553 8.55058 5.47733C8.41978 5.70453 8.34018 5.95653 8.31698 6.21473C8.30798 6.31453 8.22078 6.38893 8.12078 6.38973L6.91658 6.39893Z",
    fill: "#5D6590"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10630_189498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.0d90887511ea1e7fe297ce4977bcfa93.svg";
export { ForwardRef as ReactComponent };